<div class="TextCenter">
	<h4>User Groups</h4>
</div>

<p-table
	#mydt
	[value]="lstUserGroups"
	[loading]="loading"
	[paginator]="true"
	[(rows)]="pagerows"
	[(first)]="pagefirst"
	[showCurrentPageReport]="true"
	[resizableColumns]="false"
	sortMode="multiple"
	styleClass="p-datatable-striped"
	selectionMode="multiple"
	[(selection)]="SelectedUserGroups"
	dataKey="UserGroupID"
	(onFilter)="onHandleFilter($event)"
	(onSort)="onHandleSort($event)"
	(onRowSelect)="onRowSelect($event)"
	(onRowUnselect)="onRowUnselect($event)"
	currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
	[rowsPerPageOptions]="[5, 10, 25, 50]"
>
	<!--Headers-->
	<ng-template pTemplate="header">
		<!--Filter or Select from Dropdown-->
		<tr>
			<th></th>
			<!--Code-->
			<th>
				<p-columnFilter type="text" field="UserGroupCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
			</th>
			<!--Description-->
			<th>
				<p-columnFilter type="text" field="UserGroupDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
			</th>

			<!--User Level-->
			<th>
				<p-columnFilter field="UserLevelDesc" matchMode="equals" [showMenu]="false">
					<ng-template pTemplate="filter" let-value let-filter="filterCallback">
						<p-dropdown
							#filterUserLevelDesc
							[ngModel]="value"
							[options]="lstUserLevelDesc"
							(onChange)="filter($event.value)"
							placeholder="Any"
							[showClear]="true"
						>
							<ng-template let-value pTemplate="item">
								<span>{{ value }}</span>
							</ng-template>
						</p-dropdown>
					</ng-template>
				</p-columnFilter>
			</th>

			<!--Active Y/N-->
			<th>
				<p-columnFilter field="Active" matchMode="equals" [showMenu]="false">
					<ng-template pTemplate="filter" let-value let-filter="filterCallback">
						<p-dropdown
							#filterActive
							[ngModel]="value"
							[options]="lstActive"
							(onChange)="filter($event.value)"
							placeholder="Any"
							[showClear]="true"
						>
							<ng-template let-value pTemplate="item">
								<span>{{ value }}</span>
							</ng-template>
						</p-dropdown>
					</ng-template>
				</p-columnFilter>
			</th>
		</tr>

		<!--Column Names-->
		<tr style="height: 4rem">
			<th>
				<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
			</th>
			<th pSortableColumn="UserGroupCD">Code<p-sortIcon field="UserGroupCD"></p-sortIcon></th>
			<th pSortableColumn="UserGroupDesc">Description<p-sortIcon field="UserGroupDesc"></p-sortIcon></th>
			<th pSortableColumn="UserLevelDesc">User Level<p-sortIcon field="UserLevelDesc"></p-sortIcon></th>
			<th pSortableColumn="Active">Active<p-sortIcon field="Active"></p-sortIcon></th>
		</tr>
	</ng-template>

	<!--Data-->
	<ng-template pTemplate="body" let-usergroup>
		<tr [pSelectableRow]="usergroup" (dblclick)="onRowDblClick(usergroup)">
			<td>
				<p-tableCheckbox [pSelectableRow]="usergroup" [value]="usergroup"></p-tableCheckbox>
			</td>
			<td *ngFor="let col of cols" style="font-weight: bold">
				{{ usergroup[col.field] }}
			</td>
		</tr>
	</ng-template>
</p-table>

<div class="TextCenter TopMargin">
	<button class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-primary" (click)="onRemove()">Remove</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
